import { queryOptions } from "@tanstack/react-query"
import axios from "axios"
import { DataResponseWithPagination, SupportIssuesResponseDataSchema, SupportSchema } from "schema"
import { z } from "zod"

type Query = z.input<typeof SupportSchema>
type Response = DataResponseWithPagination<z.infer<typeof SupportIssuesResponseDataSchema>>

export const getSupportIssuesQueryKey = (query?: Query) => ["support", "issues", query]

type Props = {
  query?: Query
  onSuccess?: (data: Response) => void
}

export const supportIssuesQuery = ({ query, onSuccess }: Props = {}) => {
  return queryOptions({
    queryKey: getSupportIssuesQueryKey(query),
    queryFn: async () => {
      const response = await axios.get<Response>("/support/entities/issues", { params: query })

      onSuccess?.(response.data)

      return response.data.data
    },
  })
}
